import React from 'react';
import { Select as AntSelect } from 'antd';

/**
 * Componente de Select
 * @param {string} placeholder - Placeholder do select
 * @param {any} value - Valor selecionado
 * @param {function} onChange - Função de mudança
 * @param {Array} options - Array de opções [{value, label}]
 * @param {boolean} disabled - Se o select está desabilitado
 * @param {string} size - Tamanho do select (large, middle, small)
 * @param {boolean} showSearch - Se deve mostrar busca
 * @param {boolean} allowClear - Se permite limpar
 * @param {string} mode - Modo do select (multiple, tags)
 */
const Select = ({ 
  placeholder = 'Selecione', 
  value = undefined, 
  onChange = () => {}, 
  options = [],
  disabled = false,
  size = 'middle',
  showSearch = false,
  allowClear = false,
  mode = undefined,
  ...props 
}) => {
  return (
    <AntSelect
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      size={size}
      showSearch={showSearch}
      allowClear={allowClear}
      mode={mode}
      style={{ width: '100%' }}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      {...props}
    />
  );
};

export default Select;



